'use client';

import Link from 'next/link';
import { useSearchParams } from 'next/navigation';

import { useLocale } from '@/contexts/LocaleContext';
import { getDictionary } from '@/utils/getDictionary';

import styles from './LoadAllButton.module.scss';

type Props = {
  currentCount: number;
  totalCount: number;
  label?: string;
};

export const LoadAllButton: React.FC<Props> = (props) => {
  const { currentCount, label, totalCount } = props;

  const locale = useLocale();
  const t = getDictionary(locale);
  const searchParams = useSearchParams();
  const params = new URLSearchParams(searchParams.toString());
  params.set('limit', totalCount.toString());

  if (currentCount >= totalCount) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      {currentCount && totalCount && (
        <span className={styles.count}>
          {t('loadAllButton.showing')} {currentCount} {t('of')} {totalCount}
        </span>
      )}
      <Link
        className='button button--no-arrow'
        href={`?${params.toString()}`}
        style={{ minWidth: '180px' }}
        scroll={false}
      >
        {label || t('loadAllButton.showAll')}
      </Link>
    </div>
  );
};
